module.exports = __webpack_public_path__ + "img/nav-labtest.d50959f8.svg";